import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledMetricsContainer = styled.div`
  padding: 12px 16px;
`;

export const StyledMetricsHeader = styled.h3`
  display: flex;
  gap: 4px;
  margin: 6px 0 12px;
  ${setFontVariant('caption', colorsPalettes.carbon[250])};
  line-height: 12px;
`;

export const StyledMetricsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-bottom: 16px;
  padding-right: 16px;
`;
